// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__K9pEj","Values":"About_Values__Lm5s5","Box":"About_Box__mpJ3R"};